import { Card } from "@/components/ui/card";
import { useToastHelper } from "@/helpers/helperFunctions";
import React, { useEffect } from "react";
import CreateStrategyForm from "@/components/blocks/build/CreateStrategyForm";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  selectedBrokerState,
  selectedTimeFrameState,
  setSelectedSymbolState,
} from "@/Atoms/strategy/StrategyFormAtom";
import TradingGraph from "@/components/charts/TradingGraph";
import { useMediaQuery } from "@react-hook/media-query";
import { BUILD_CANVAS_STRATEGY, CURRENT_DEFAULT_SYMBOL } from "@/config/logos";
import TrendingTradres from "../marketplace/TrendingTradres";
import TrendingStrategies from "../marketplace/TrendingStrategies";
import CanvasIframe from "@/components/canvas/CanvasIframe";
import { EarningsCalendarWidget } from "@/components/EarningsCalendarWidget";
import { useTranslation } from "react-i18next";
import { guideModalAtom } from "@/Atoms/modal/DialogueAtoms";
import TrendingPairsTrading from "../marketplace/TrendingPairsTrading";
import StrategyLab from "../marketplace/StrategyLab";
const BuildPage = () => {
  const { t } = useTranslation("build-page");
  const toastNotify = useToastHelper();
  const [selectedSymbol] = useRecoilState(setSelectedSymbolState);
  const [selectedTimeFrame] = useRecoilState(selectedTimeFrameState);
  const [broker] = useRecoilState(selectedBrokerState);
  const setGuideModal = useSetRecoilState(guideModalAtom);

  const isMobile = useMediaQuery("only screen and (max-width: 965px)");

  useEffect(() => {
    if (typeof window !== "undefined") {
      // @ts-ignore
      window.toastNotify = toastNotify;
      return () => {
        // @ts-ignore
        delete window.toastNotify;
      };
    }
  }, [toastNotify]);

  useEffect(() => {
    // removing coupon from local storage
    localStorage.removeItem("coupon");
  }, []);

  return (
    <div id="create-new-strategy-form" className="px-4 sm:px-auto">
      <div className="flex md:flex-row md:flex-nowrap flex-wrap gap-5 my-5 w-full ">
        <Card className={"w-full lg:w-[795px] lg:max-w-[24rem]"}>
          <CreateStrategyForm />
        </Card>

        <Card
          className={
            "w-full lg:w-[100%-504px]  h-auto rounded-xl p-2 hidden md:block"
          }
        >
          <div className="flex flex-col gap-2 items-center justify-center rounded-xl h-80 md:h-full  w-full">
            {isMobile || (selectedSymbol && selectedTimeFrame) ? (
              <div className="w-full  h-full build-page mt-[-10px] relative ">
                <div className="absolute z-50 right-20 top-2"></div>
                <TradingGraph
                  symbol={selectedSymbol ?? CURRENT_DEFAULT_SYMBOL}
                  timeframe={
                    selectedTimeFrame?.value
                      ? `${selectedTimeFrame?.value}`
                      : "60m"
                  }
                  broker_id={broker}
                ></TradingGraph>

                <div id="chart_widget" tabIndex={-1}></div>
              </div>
            ) : (
              <CanvasIframe
                src={`/demo?keygen=${BUILD_CANVAS_STRATEGY}`}
              ></CanvasIframe>
            )}
          </div>
        </Card>
      </div>
      <div className="flex flex-col w-full h-full lg:flex-row gap-2 ">
        <div className="w-full lg:w-1/3 ">
          <TrendingTradres />
        </div>
        <div className="w-full lg:w-1/3 mt-5 lg:mt-0 ">
          <StrategyLab></StrategyLab>
        </div>
        <div className="w-full lg:w-1/3 mt-5 lg:mt-0 ">
          <TrendingStrategies></TrendingStrategies>
        </div>
      </div>
    </div>
  );
};
export default BuildPage;
